import "./index.css"
import ReactDOM from "react-dom"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import React from "react"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import grey from "@mui/material/colors/grey"
import KcWrapper from "./auth/wrapper"
import { BrowserRouter } from "react-router-dom"
import theme_colors from "./configs/theme_colors.json"

const theme = createTheme({
  palette: {
    primary: {
      main: theme_colors.ndoh_green,
    },
    secondary: {
      main: grey[100],
    },
  },
})

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <KcWrapper>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </KcWrapper>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
